import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>

      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
